import { render, staticRenderFns } from "./TicketEditModal.vue?vue&type=template&id=ca47a70a&scoped=true&"
import script from "./TicketEditModal.vue?vue&type=script&lang=js&"
export * from "./TicketEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketEditModal.vue?vue&type=style&index=0&id=ca47a70a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca47a70a",
  null
  
)

export default component.exports